import { buildFetchMutations } from '@/store/extensions/fetch';
import { buildCreateMutations } from '@/store/extensions/create';
import { buildUpdateMutations } from '@/store/extensions/update';

export default {
  ...buildFetchMutations(['fetchTimesheets', 'fetchSingleTimesheet', 'fetchRejectedTimesheets', 'fetchPendingTimesheets']),
  ...buildCreateMutations(['createTimesheet']),
  ...buildUpdateMutations(['updateTimesheet', 'changeStatus']),
};



// WEBPACK FOOTER //
// ./src/store/modules/timesheet/mutations.js